webpackJsonp([263819877693416],{

/***/ 459:
/***/ (function(module, exports) {

	module.exports = {"data":{"contentfulBlogPost":{"title":"Manila Street Astronomers at UPTC","publicationDate":"November 07, 2017","content":{"content":"<iframe width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/_lx1p_2zwxQ\" frameborder=\"0\" allow=\"autoplay; encrypted-media\" allowfullscreen></iframe>"},"thumbnail":{"file":{"url":"//images.ctfassets.net/1o5ly3na7qu2/5s4q40S4dU8GYkYyq8oWKA/3c2937cbcc93f6b26976d2fdfe0cbf75/unnamed.jpg"}}}},"pathContext":{"id":"c4k63VPubKwAKGMAoyMgsIm"}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-manila-street-astronomers-at-uptc-e318676b30ba1c5b30c1.js